export * from './community-video-admin/community-video.page';
